import type { FeatureRoute } from '../types';
import { NoteDetailPage } from './NoteDetailPage';
import { NoteFormPage } from './NoteFormPage';
import { NotePrintPage } from './NotePrintPage';
import { PurchaseReturnDetailPage } from './PurchaseReturnDetailPage';
import { PurchaseReturnFormPage } from './PurchaseReturnFormPage';
import { ReturnsPage } from './ReturnsPage';
import { SalesReturnDetailPage } from './SalesReturnDetailPage';
import { SalesReturnFormPage } from './SalesReturnFormPage';

/** Routes owned by this feature (paths are relative to the app root, e.g. 'customers/:id'). */
export const routes: FeatureRoute[] = [
  { path: 'returns', element: <ReturnsPage /> },
  { path: 'returns/sales/new', element: <SalesReturnFormPage /> },
  { path: 'returns/sales/:id', element: <SalesReturnDetailPage /> },
  { path: 'returns/purchase/new', element: <PurchaseReturnFormPage /> },
  { path: 'returns/purchase/:id', element: <PurchaseReturnDetailPage /> },
  { path: 'returns/credit-notes/new', element: <NoteFormPage key="credit" kind="credit" /> },
  { path: 'returns/credit-notes/:id', element: <NoteDetailPage key="credit" kind="credit" /> },
  { path: 'returns/credit-notes/:id/print', element: <NotePrintPage kind="credit" /> },
  { path: 'returns/debit-notes/new', element: <NoteFormPage key="debit" kind="debit" /> },
  { path: 'returns/debit-notes/:id', element: <NoteDetailPage key="debit" kind="debit" /> },
  { path: 'returns/debit-notes/:id/print', element: <NotePrintPage kind="debit" /> },
];
